import React from 'react';
import PropTypes from 'prop-types';
import Product from './Product';
import Card from './Card';
import CalculateProductSize from './CalculateProductSize';

import { SizeMe } from 'react-sizeme';

class ProductContainer extends React.Component {
  state = {
    sku: undefined,
    contentSku: 1,
    duration: undefined,
    activeContents: undefined,
    activeProducts: [],
  };

  componentDidMount() {
    const activeProducts = this.renderProducts(this.props.items, this.props.activeParticipant, this.props.settings);
    if (activeProducts.length === 1) {
      const {
        sku, duration, name, cost, contentSku,
      } = activeProducts[0];

      this.handleProductClick({
        sku, duration, name, cost, contentSku,


      })();
    }
  }


  componentWillReceiveProps(nextProps) {
    let activeProduct;

    activeProduct = this.renderProducts(nextProps.items, nextProps.activeParticipant, nextProps.settings);


    if (nextProps.activeProduct !== undefined) {
      const activeContent = this.activeContents(nextProps.items, nextProps.activeProduct);
      if (activeContent !== undefined) {
        activeProduct = activeContent;
      }
    }
    // Om den inte finns så måste vi kolla produkten

    if (nextProps.activeParticipant !== this.props.activeParticipant) {
      // Ifall vi får nya participants måste vi ändra tiden
      // participants kommer som en prop. Är den ifylld skicka upp den med de nya data?

      if (activeProduct) {
        const chosenProduct = activeProduct.find(({ sku }) => sku === this.state.sku);


        if (chosenProduct !== undefined) {
          const {
            sku, duration, name, cost, contentSku,
          } = chosenProduct;

          if (contentSku !== undefined) {
            // alert('den här körs');
            this.handleProductClick({
              sku, duration, name, cost, contentSku,


            })();
          }
        }
      }
    }
  }

  findProduct = () => {
    const { sku: stateSku, contentSku } = this.state;
    if (stateSku === undefined || contentSku === undefined) {
      return undefined;
    }
    const products = this.props.items;

    const activeProduct = products.find(({ sku }) => sku === stateSku);
    const activeContents = activeProduct.content.find(({ sku }) => sku === contentSku);

    return activeContents;
  }


  handleProductClick = click => () => {
    let contentSku;

    if (click.contentSku) {
      contentSku = click.contentSku;
    }

    this.setState({ sku: click.sku, duration: click.duration, contentSku }, () => {
      this.props.onClickProduct(click);
    });
  };

  checkIfProductIsComplete = () => {
    const { sku, duration } = this.state;

    if (sku !== undefined &&
    duration !== undefined) {
      this.props.onClickProduct({ sku, duration });
    }
  };

  renderProducts = (products, chosenParticipants, settings) => {
    const activeProducts = products.map((item) => {
      const content = item.content.find(({ participants }) => participants >= chosenParticipants);

      if (content === undefined) {
        return {};
      }

      // If the customer has additional choises ex, by length or package write "från"
      // todo get this from language part of api later
      let contentPrefix = '';
      let durationChecker = content.duration;
      let contentSku = content.sku;
      if (item.type === 'flat') {
        // for this to be true from the content has to be more than one
        if (item.content.length > 1) {
          contentPrefix = 'Från ';
          durationChecker = undefined;
          contentSku = undefined;
        }
      }
      let cost = content.cost;
      if (settings.sumProduct) {
        cost = content.cost * chosenParticipants;
      }


      // Spara aktuell "content" för att visa tidsåtgång och pris för de valda deltagarna
      /*

      description: "Obegränsat med bollar."
      image: "http://homestead.test/client/products/1509026272.png"
      name: "Paintball Deluxe"
      sku: 10
      type: "flat"
       */


      return {
        name: item.name,
        description: item.description,
        image: item.image,
        cost: Math.round(content.cost),
        costDisplay: contentPrefix + Math.round(cost),
        duration: durationChecker,
        durationDisplay: contentPrefix + content.duration,
        sku: item.sku,
        contentSku,
        type: item.type,
      };
    });
    this.setState({ activeProducts });

    return activeProducts;
  };

  activeContents = (products, stateSku) => {
    const activeProduct = products.find(({ sku }) => sku === stateSku);

    if (activeProduct.type === 'flat' && activeProduct.content.length > 1) {
      const contentPrefix = '';

      const activeContents = activeProduct.content.map(item =>

        ({
          name: `${activeProduct.name} - ${item.name}`,
          description: item.description,
          image: item.image,
          cost: Math.round(item.cost),
          costDisplay: contentPrefix + Math.round(item.cost),
          duration: item.duration,
          durationDisplay: contentPrefix + item.duration,
          contentSku: item.sku,
          sku: activeProduct.sku,
          type: activeProduct.type,
        }));
      this.setState({ activeContents: [...activeContents] });
    } else {
      this.setState({ activeContents: undefined });
    }
  };


  render() {
    const {
      items,
      onClickProduct,
      lang,
      activeParticipant,
      settings,
      master,
    } = this.props;
    const {
      activeProducts,
      activeContents,
      sku: stateSku,
      duration: stateDuration,
      contentSku: stateContentSku,
    } = this.state;

    const showExtras = false;


    return (
      <React.Fragment>
        <Card title={lang.topic}>
          <CalculateProductSize
            nrOfProducts={5}
          >
            {activeProducts.map(({
                                     index, sku, duration, name, cost, contentSku, ...rest
                                   }) => {
                const clicked = sku === stateSku;


                return (
                  <Product
                    key={sku}
                    sku={sku}
                    master={master}
                    activeParticipant={activeParticipant}
                    name={name}
                    lang={lang}
                    cost={cost}
                    clicked={clicked}
                    onClick={this.handleProductClick({
                      sku, duration, name, cost, contentSku,
                    })}
                    {...rest}
                  />
                );
              })}
          </CalculateProductSize>
          {/*
          <SizeMe render={({ size }) => {
            const maxPerRow = 5;

            const mediumMaxPerRow = 3;
            const smallMaxPerRow = 2;

            const numberOfProducts = activeProducts.length;

            let perRow = numberOfProducts;
            if (numberOfProducts > maxPerRow) {
              perRow = maxPerRow;
            }

            if (size.width < 700) {
              perRow = mediumMaxPerRow;
            }

            if (size.width < 500) {
              perRow = smallMaxPerRow;
            }

            const testWidth = 100 / perRow;
            return (
              <div className="row is-flex">
                {activeProducts.map(({
                                       index, sku, duration, name, cost, contentSku, ...rest
                                     }) => {
                  const clicked = sku === stateSku;


                  return (
                    <Product
                      key={sku}
                      sku={sku}
                      master={master}
                      width={testWidth}
                      activeParticipant={activeParticipant}
                      name={name}
                      lang={lang}
                      cost={cost}
                      clicked={clicked}
                      onClick={this.handleProductClick({
                        sku, duration, name, cost, contentSku,
                      })}
                      {...rest}
                    />
                  );
                })}

              </div>
            );
}


            }
          />
          */}
        </Card>
        { activeContents !== undefined && (
        <Card title={lang.sub_topic}>

          <CalculateProductSize
            nrOfProducts={5}
          >

            {activeContents.map(({
 index, sku, contentSku, duration, name, cost, ...rest
}) => {
            const clicked = contentSku === stateContentSku;
            return (
              <Product
                key={contentSku}
                sku={sku}
                master={master}
                activeParticipant={activeParticipant}
                name={name}
                lang={lang}
                cost={cost}
                clicked={clicked}
                onClick={this.handleProductClick({
                  sku, duration, name, cost, contentSku,
                })}
                {...rest}
              />
            );
          })}
          </CalculateProductSize>
        </Card>
    )}
      </React.Fragment>
    );
  }
}

ProductContainer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onClickProduct: PropTypes.func.isRequired,
  activeParticipant: PropTypes.number,
  activeProduct: PropTypes.number,
};

export default ProductContainer;



// WEBPACK FOOTER //
// ./src/components/Resource/components/ProductContainer.js